import React, {useEffect, useState} from 'react';
import ImageComponent from "./ImageComponent";
import {useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {appUrls} from "../../config/Constants";
import {hasAValue} from "../../uitls/SharedFunctions";

export default function NewLocalStoresDiscountCard({item, hideFavorite = false}) {
    const appLanguageRS = useSelector(state => state.appLanguageRS);
    let contentLanguage = appLanguageRS === "en"? "en": "nl"

    let language = appLanguageRS
    const {city} = useParams();

    return (
        <div className={"card radius-15 border-0 w-100 store-discount-card cursor-pointer shadow"}
             onClick={() => goToInfo()}>
            <ImageComponent src={appUrls.image_url + item.imageId} className="homepage-online-section-online-card-background" alt={`studentenkorting-${item.localization[contentLanguage]?.title}`}/>
            <div className="card-body row store-discount-card-body">
                <div className={"col-12 d-flex justify-content-center"}>
                    <div
                        className="bg-white radius-15 online-discount-card-logo shadow d-flex justify-content-center align-items-center">
                        <ImageComponent src={appUrls.image_url + item.iconId}
                                        alt="" className={"online-discount-card-logo-img radius-15"}/>
                    </div>


                </div>
                <div className={"col-12 text-center"}>
                    <h4 className="w-100 mt-1 text-knaek-title">{item.localization[contentLanguage]?.subtitle}</h4>
                    <h6 className="w-100 text-knaek-regular mt-2">{item.localization[contentLanguage]?.title}</h6>
                </div>
            </div>

        </div>
    );


    function hyphenateAndEncode(str) {
        // Replace spaces and forward slashes with hyphens, then URI encode the result
        return encodeURIComponent(str.replace(/\s+|\//g, '-'));
    }

    function goToInfo() {
        let targetCity = hasAValue(city) ? city : item.cityNames[0];
        let targetName = item.companyName
        let targetId = item.actionId;

        window.location.href = `/studentenkorting/${hyphenateAndEncode(targetCity)}/${hyphenateAndEncode(targetName)}/${encodeURIComponent(targetId)}`;
    }

}
